<div>
    <span class="ec-item-box-title">{{ title | translate }}: </span>
    {{ text }}
</div>

